/**
 * Off-platform Stripe: customers pay via the seller's Stripe Payment Link.
 * BookAPT does not process or hold funds.
 */

const STRIPE_PAYMENT_HOSTS = [
  'stripe.com',
  'buy.stripe.com',
  'checkout.stripe.com',
  'invoice.stripe.com',
  'pay.stripe.com',
];

export function isStripeDirectPaymentUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.toLowerCase();
    return STRIPE_PAYMENT_HOSTS.some(
      (h) => host === h || host.endsWith(`.${h}`)
    );
  } catch {
    return false;
  }
}

export function normalizeStripeDirectInput(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) {
    return null;
  }

  let candidate = trimmed;
  if (!/^https?:\/\//i.test(candidate)) {
    candidate = `https://${candidate.replace(/^\/+/, '')}`;
  }

  return isStripeDirectPaymentUrl(candidate) ? candidate : null;
}

export function maskStripeDirectUrl(url: string): string {
  try {
    const parsed = new URL(url);
    const path = parsed.pathname.replace(/\/$/, '');
    const shortPath = path.length > 24 ? `${path.slice(0, 24)}…` : path;
    return `${parsed.hostname}${shortPath || ''}`;
  } catch {
    return 'Stripe payment link';
  }
}
